import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { message } from "antd";
import { Modal, Toast } from "antd-mobile";
import $ from "jquery";
import PsContext from "../../context";
import ModuleAccess from "../../context/moduleAccess";
import { MOB_ICONS, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import DirectHallTicket from "./directHallticket";
import CoeHallTicket from "./coeHallticket";

const HallTicket = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState([]);

  return (
    <>
      <Header title="Dashboard" />
      <div className="page-content-wrapper">
        <div className="container py-4">

          <DirectHallTicket />

        </div>
      </div>
    </>
  );
};
export default HallTicket;
